export const Budget = {
	isBudgetLoading: false,
	isArchiveBudgetLoading: false,
	isBudgetResultLoading: false,
	budget: null,
	budgets: [],
	archiveBudgets: [],
	results: null,
	budgetTotals: 0,
	archiveBudgetTotals: 0
};
